const disallowedProductCardSpecs = ['CARB EO#', 'MFG. Part #']

export default disallowedProductCardSpecs
